import { Fragment, useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { MdVisibility } from 'react-icons/md';
import Loading from '../../../Components/Loading';
import { CustomTable } from '../../Flow/styles';
import { BoxHeaderCard, BoxTextsTitleCard, TextsTitleCard, TitleHeadCard } from '../../Home/style';
import { InfoIcon } from '../../RequestDetails/styles';
import { ModalViewFile } from './ModalViewFile';

interface FilesReceivedProps {
  filesReceived: Array<{
    id: string;
    nome: string;
    url: string;
  }>
  loading: boolean
}

export function FilesReceived({filesReceived, loading }: FilesReceivedProps){
  const [docReceivedSelected, setDocReceivedSelected] = useState<{
    id: string;
    nome: string;
    url: string;
  }>();
  const [showModalDocReceived, setShowModalDocReceived] = useState<boolean>(false);

  const handleShowDocReceived = (doc: {
    id: string;
    nome: string;
    url: string;
  }): void => {
    setDocReceivedSelected(doc);
    setShowModalDocReceived(true);
  };

  return (
    <>
    {!!filesReceived?.length && (
      <>
        <Card>
        <BoxHeaderCard>
          <TitleHeadCard>
            <InfoIcon />
            <BoxTextsTitleCard>
              <TextsTitleCard>Documentos recebidos</TextsTitleCard>
            </BoxTextsTitleCard>
          </TitleHeadCard>
        </BoxHeaderCard>
        <CustomTable striped responsive>
        <ModalViewFile 
          showModalDocReceived={showModalDocReceived}
          setShowModalDocReceived={setShowModalDocReceived}
          docReceivedSelected={docReceivedSelected} 
        />
          <thead className="table-header">
            <tr>
              <th>Ordem</th>
              <th>Nome</th>
              <th>Hash</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody className="table-body">
            {loading ? (
              <tr className="text-center">
                <td colSpan={5}>
                  <Loading />
                </td>
              </tr>
            ) : (
              <>
              {filesReceived?.map(
                    (item, index) => {
                      if (item.id) {
                        return (
                          <Fragment key={item.id}>
                            <tr>
                              <td>{index + 1}</td>
                              <td>{item.nome}</td>
                              <td>{item.id}</td>
                              <td className="text-right">
                                <Button
                                  variant="outline-secondary mx-2"
                                  onClick={() =>
                                    handleShowDocReceived(item)
                                  }
                                >
                                  <MdVisibility size={22} />
                                </Button>
                              </td>
                            </tr>
                          </Fragment>
                        );
                      }
                      return null
                    }
                  )}
              </>
            )}
          </tbody>
        </CustomTable>
      </Card>
      </>
    )}
    </>
  )
}